import { useGetExpensesSummary } from 'api/expenses/use-get-expenses-summary';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { useExpensesFiltersStore } from 'shared/stores/use-expenses-filters.ts';
import { numberFormatter } from 'shared/utils/numbers/formatter';
import { ListSummary } from 'components/common/list-summary';

const ExpensesSummaryComponent = () => {
  const { filters, search } = useExpensesFiltersStore();
  const { data, isLoading } = useGetExpensesSummary({ search, filters });

  return (
    <ListSummary isLoading={isLoading}>
      Expenses count: {numberFormatter(data?.count || 0)} / Total expenses: {numberFormatter(data?.totalAmount || 0)}€
    </ListSummary>
  );
};

export const ExpensesSummary = withRoleGuard(ExpensesSummaryComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
